import { render, staticRenderFns } from "./CandidateFrontsheet.vue?vue&type=template&id=0df52c30&scoped=true"
import script from "./CandidateFrontsheet.vue?vue&type=script&lang=js"
export * from "./CandidateFrontsheet.vue?vue&type=script&lang=js"
import style0 from "./CandidateFrontsheet.vue?vue&type=style&index=0&id=0df52c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df52c30",
  null
  
)

export default component.exports